import { Table } from "react-bootstrap";
import React from "react";
import { Link } from "react-router-dom";

function ProjectTeam({ teamSize }) {
	return (
		<div className="col-12 graphDiv1 h-100">
			<div className="m-2 p-3 title">My Projects</div>
			{teamSize.length !== 0 ? (
				<Table responsive hover className="text-center">
					<thead>
						<tr className="tableRowColor">
							<th>Project Name</th>
							<th>Team Size</th>
						</tr>
					</thead>
					{teamSize.map((item, i) => {
						return (
							<tbody key={i}>
								<tr
									className={
										i % 2 === 0 ? "bgColor1" : "bgColor2"
									}
								>
									<td>
										<Link
											to={{
												pathname: `/teamDetails/${item.projectId}`,
												state: {
													name: item.projectName,
												},
											}}
										>
											<span className="ticketIdStyle">
												{item.projectName}
											</span>
										</Link>
									</td>
									<td>{item.teamSize}</td>
								</tr>
							</tbody>
						);
					})}
				</Table>
			) : (
				<div className="text-center mt-2"> No data found </div>
			)}
		</div>
	);
}

export default ProjectTeam;
